import { useQuery } from '@tanstack/react-query';
import { IAICampaignQuota } from '../../models/AICampaign';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'aiCampaign/quota';

export function useAICampaignQuota({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IAICampaignQuota>('AICampaign/quota', 'GET');
		},
		queryKey: [BASE_QUERY_KEY],
		meta: {
			toastErrorMessage: 'Failed to load your remaining AI campaign allowance',
		},
	});
}

export const invalidateAICampaignQuota = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
